// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Fspk","icon":"styles_icon__20kwl"};